// @ts-nocheck legacy file transformed to TS
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from 'react-intl'
import { CatalogContext, withNotificationContext } from 'legacy/common/context'
import { fetchAisle, fetchDepartment } from 'legacy/common/api'
import instacart from 'legacy/common/instacart'
import { errors } from 'utils/error-handling/errors'

const resolveIds = (pathname = '', query) => {
  const department = pathname.match(/departments\/(\d+)/)
  const aisle = pathname.match(/aisles\/(\d+)/)

  return {
    department_id: department != null ? department[1] : query.department_ids,
    aisle_id: aisle != null ? aisle[1] : query.aisle_ids,
  }
}

class Catalog extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    query: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    match: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    history: PropTypes.object.isRequired,
    notifyError: PropTypes.func.isRequired,
    notify: PropTypes.func.isRequired,
    children: PropTypes.node,
  }

  constructor(props) {
    super(props)
    const {
      query,
      history: {
        location: { pathname },
      },
    } = props
    const { department_id, aisle_id } = resolveIds(pathname, query)

    this.state = {
      department_id,
      aisle_id,
      department: undefined,
      aisle: undefined,
      aisleVisibilityModalOpen: false,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      history: {
        location: { pathname },
      },
      query,
    } = nextProps
    const { department_id, aisle_id } = resolveIds(pathname, query)

    if (department_id !== prevState.department_id || aisle_id !== prevState.aisle_id) {
      return {
        department_id,
        aisle_id,
      }
    }

    return null
  }

  componentDidMount() {
    this.loadDepartment()
    this.loadAisle()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.aisle_id !== this.state.aisle_id) {
      this.loadAisle()
    }

    if (prevState.department_id !== this.state.department_id) {
      this.loadDepartment()
    }
  }

  handleAisleVisibilityModal = isOpen => {
    this.setState({ aisleVisibilityModalOpen: isOpen })
  }

  setAisleVisibility = visibilityToSet => {
    const actionString = visibilityToSet ? 'show' : 'hide'

    if (this.state.aisle) {
      const { partner_id, warehouse_id } = this.props.match.params
      const { department_id, aisle_id } = this.state
      instacart.go
        .put(
          `/v1/partners/${partner_id}/warehouses/${warehouse_id}/departments/${department_id}/aisles/${aisle_id}`,
          { data: { visible: visibilityToSet } }
        )
        .then(() => {
          this.notifyVisibilitySuccess(actionString)
          this.handleAisleVisibilityModal(false)
          this.setState(prevState => ({ aisle: { ...prevState.aisle, visible: visibilityToSet } }))
        })
        .catch((message) => {
          this.notifyVisibilityError(actionString, message?.errors?.[0])
          this.setState(prevState => ({
            aisle: { ...prevState.aisle, visible: !visibilityToSet },
          }))
        })
    }
  }

  async loadDepartment() {
    const { department_id } = this.state

    if (!department_id) {
      return this.setState({
        department: null,
      })
    }

    try {
      const { data: department } = await fetchDepartment({
        ...this.props.match.params,
        department_id,
      })
      this.setState({
        department,
      })
    } catch (e) {
      errors.captureException(e)
    }
  }

  async loadAisle() {
    const { department_id, aisle_id } = this.state

    if (!department_id || !aisle_id) {
      this.setState({
        aisle: null,
      })

      return
    }

    try {
      const { data: aisle } = await fetchAisle({
        ...this.props.match.params,
        department_id,
        aisle_id,
      })

      this.setState({
        aisle,
      })
    } catch (e) {
      // do nothing
    }
  }

  notifyVisibilitySuccess(actionString) {
    this.props.notify(
      <span>
        <FormattedMessage
          id={`aisles.visibility.async.${actionString}.success`}
          values={{ aisleName: this.state.aisle.name }}
        />
        <FormattedMessage id="aisles.visibility.async.timingClause" />
      </span>
    )
  }

  notifyVisibilityError(actionString, message?: string = null) {
    const msg = message ? message : <FormattedMessage
        id={`aisles.visibility.async.${actionString}.error`}
        values={{ aisleName: this.state.aisle.name }}
    />
    this.props.notifyError(msg)
  }

  render() {
    return (
      <CatalogContext.Provider
        value={{
          ...this.state,
          setAisleVisibility: this.setAisleVisibility,
          handleAisleVisibilityModal: this.handleAisleVisibilityModal,
        }}
      >
        {this.props.children}
      </CatalogContext.Provider>
    )
  }
}

export default withNotificationContext(Catalog)
